
// Start: Schema table type
export type ISTColumnType = 'string' | 'date' | 'time' | 'number' | 'img'  | 'checkbox' | 'link' | 'status' | 'badge' | 'tag' | 'radio' | 'currency' | 'yn' | 'no';
// End: Schema table type

// Start: Schema readview type
export type IRVStatus = 'success' | 'fail' | 'partial';
// End: Schema readview type

// Start: Schema table interface
export interface ISTColumnEnum{
  text: string;
  value:any;
}
export interface ISTColumn{
  key: string;// eg. taskName, assignee, etc...
  title: string;// eg. Task name, Assignee
  type: ISTColumnType;
  sort?: true;
  filter?: true;
  enum?: ISTColumnEnum[];
}
export interface ISTAction{
  name: string;
  icon?: string;
  onlyIcon?: boolean;
}

export interface ISTData{
  columns?: ISTColumn[];
  data?:any;
  actions?: ISTAction[];
}

export interface IOnRowCell{
  column: ISTColumn;
  data:any;
}
// End: Schema table interface

// Start: Schema readview interface
export interface IReadView{
  key: string;
  text: string;
  lableId?: string;
  status?: IRVStatus;
  link?: string; // hyperlink or redirect link
  alert?: string; // provide string it will show alert with provided value
}

// It is similar to BpsVariables data
export interface IReadViewRawDataWrapper{
  [key: string] : IReadViewRawData;
}

export interface IReadViewRawData{
  value: any;
  type: string;
  valueInfo?: Object;
}
// End: Schema readview interface

// Tab view data
export interface TabView{
  key: string;
  data:any;
  icon?:any;
}

export enum ISchemaServiceEvents{
  // eslint-disable-next-line no-unused-vars
  WORK_FLOW_REQUEST_VIEW
}

export interface ISchemaServiceEventsData{
  event: ISchemaServiceEvents;
  data:any;
}

